import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { AddStopsHelpPageRoutingModule } from './add-stops-help-routing.module';

import { AddStopsHelpPage } from './add-stops-help.page';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, TranslateModule.forChild(), AddStopsHelpPageRoutingModule],
  declarations: [AddStopsHelpPage]
})
export class AddStopsHelpPageModule {}
